import { API } from "../APIs";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class JiraService {
  tokens: any | Tokens;
  get = API.jira + "get/";
  post = API.jira + "post/";
  put = API.jira + "put/";

  constructor() {
    this.tokens = TokenValidator();
  }

  async createTransferComplaint(data: any) {
    try {
      let response = await fetch(
        this.post + `request/createTransferComplaint`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createGeneralComplaint(data: any) {
    try {
      let response = await fetch(this.post + `request/CreateGeneralComplaint`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createBillComplaint(data: any) {
    try {
      let response = await fetch(this.post + `request/CreateBillComplaint`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createPOSComplaint(data: any) {
    try {
      let response = await fetch(
        this.post + `request/CreatePosCashWithdrawalComplaint`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createFinanceComplaint(data: any) {
    try {
      let response = await fetch(this.post + `request/CreateFinanceComplaint`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async createSavingsComplaint(data: any) {
    try {
      let response = await fetch(this.post + `request/CreateSavingsComplaint`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async AddComplaint(data: any) {
    try {
      let response = await fetch(this.post + `request/AddComplaint`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getJiraRequestLog(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `jiraRequestLog/getAggregatorPaged/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async jiraRequestLogDetails(id: string) {
    try {
      let response = await fetch(this.get + `jiraRequestLog/getDetails/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async complaintDashboard() {
    try {
      let response = await fetch(
        this.get + `jiraRequestLog/getAggregatorComplaintDashboard`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getBillTypeService() {
    try {
      let response = await fetch(this.get + `Request/GetBillTypes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
